export enum ExamDocumentType {
    Exam = 0,
    Attachment = 1,
    Draft = 2,
    SubmitExam = 3,
    SubmitAttachment = 4,
    SubmitDraft = 5,
}